'use client';

import { CustomImage } from 'components/shared/custom-image';
import styles from './Studies.module.css';

/**
 * The study thumbnail, as its own client island.
 *
 * `next/image` is a Client Component and `CustomImage` hands it a `loader`
 * function, which cannot cross a server→client boundary (it throws at runtime,
 * and the build does not catch it — see
 * docs/app-router-migration/02-rendering-and-data-fetching.md). Isolating the
 * image here is what lets Studies itself stay a Server Component.
 *
 * main spelled `muted` as the transient prop `$muted`; styled-components kept
 * it off the DOM, and so does this.
 */
const StudyThumb = ({ src, muted }: { src: string; muted?: boolean }) => (
  <CustomImage
    src={src}
    alt=""
    aria-hidden="true"
    width={72}
    height={72}
    className={muted ? `${styles.thumb} ${styles.thumbMuted}` : styles.thumb}
  />
);

export default StudyThumb;
